import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SaveSlackIntegrationCommandClass;
function SaveSlackIntegrationCommand() {
  if (SaveSlackIntegrationCommandClass === VOID) {
    class $ {
      constructor(partyId, channel, team) {
        this.partyId_1 = partyId;
        this.channel_1 = channel;
        this.team_1 = team;
      }
      copy_vuaen_k$(partyId, channel, team) {
        return new (SaveSlackIntegrationCommand())(partyId, channel, team);
      }
      copy$default_74imuw_k$(partyId, channel, team, $super) {
        partyId = partyId === VOID ? this.partyId_1 : partyId;
        channel = channel === VOID ? this.channel_1 : channel;
        team = team === VOID ? this.team_1 : team;
        return $super === VOID ? this.copy_vuaen_k$(partyId, channel, team) : $super.copy_vuaen_k$.call(this, partyId, channel, team);
      }
      toString() {
        return 'SaveSlackIntegrationCommand(partyId=' + this.partyId_1.toString() + ', channel=' + this.channel_1 + ', team=' + this.team_1 + ')';
      }
      hashCode() {
        var result = this.partyId_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.channel_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.team_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationCommand()))
          return false;
        if (!this.partyId_1.equals(other.partyId_1))
          return false;
        if (!(this.channel_1 === other.channel_1))
          return false;
        if (!(this.team_1 === other.team_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationCommand');
    SaveSlackIntegrationCommandClass = $;
  }
  return SaveSlackIntegrationCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher3kdydho2ojhnk,
  SaveSlackIntegrationCommand as SaveSlackIntegrationCommand3vduj8nfpy1wd,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationCommand.mjs.map
